import ACTIONS from '../actionTypes/application'

const initialState = {
  appList: [],
  fetchingAppList: false,
  errorFetchingAppList: false,
  application: null,
  isFetchingCurrentApp: false,
  isUpdatingClientSecret: false,
  isGeneratingClientCertificate: false,
  isStartingSyncJob: false
}

const ApplicationReducer = (state = initialState, action) => {
  switch (action.type) {

    // getApplicationList
    case ACTIONS.START_GET_APP_LIST:
      return {
        ...state,
        fetchingAppList: true
      }
    case ACTIONS.GET_APP_LIST_SUCCESS:
      return {
        ...state,
        appList: action.payload,
        fetchingAppList: false,
        errorFetchingAppList: false
      }
    case ACTIONS.GET_APP_LIST_FAILED:
      return {
        ...state,
        fetchingAppList: false,
        errorFetchingAppList: true
      }

    // getApplicationById
    case ACTIONS.START_GET_APP_BY_ID:
      return {
        ...state,
        isFetchingCurrentApp: true
      }
    case ACTIONS.GET_APP_BY_ID_SUCCESS:
      return {
        ...state,
        application: action.payload,
        isFetchingCurrentApp: false,
      }
    case ACTIONS.GET_APP_BY_ID_FAILED:
      return {
        ...state,
        application: null,
        isFetchingCurrentApp: false,
      }

    // updateClientSecret
    case ACTIONS.START_UPDATE_CLIENT_SECRET:
      return {
        ...state,
        isUpdatingClientSecret: true
      }
    case ACTIONS.UPDATE_CLIENT_SECRET_SUCCESS:
      return {
        ...state,
        isUpdatingClientSecret: false,
      }
    case ACTIONS.UPDATE_CLIENT_SECRET_FAILED:
      return {
        ...state,
        isUpdatingClientSecret: false,
      }

    // generateClientCertificate
    case ACTIONS.START_GENERATE_CLIENT_CERTIFICATE:
      return {
        ...state,
        isGeneratingClientCertificate: true
      }
    case ACTIONS.GENERATE_CLIENT_CERTIFICATE_SUCCESS:
      return {
        ...state,
        isGeneratingClientCertificate: false,
      }
    case ACTIONS.GENERATE_CLIENT_CERTIFICATE_FAILED:
      return {
        ...state,
        isGeneratingClientCertificate: false,
      }

    // startSyncApplictionsJob
    case ACTIONS.START_APP_SYNC_JOB:
      return {
        ...state,
        isStartingSyncJob: true
      }
    case ACTIONS.START_APP_SYNC_JOB_SUCCESS:
      return {
        ...state,
        isStartingSyncJob: false,
      }
    case ACTIONS.START_APP_SYNC_JOB_FAILED:
      return {
        ...state,
        isStartingSyncJob: false,
      }

    // Default
    default:
      return state
  }
}

export default ApplicationReducer